import { render, staticRenderFns } from "./delClass.vue?vue&type=template&id=23739962&scoped=true"
import script from "./delClass.vue?vue&type=script&lang=ts"
export * from "./delClass.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23739962",
  null
  
)

export default component.exports